var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1):_c('div')
}
var staticRenderFns = []

export { render, staticRenderFns }